<template>
<div id="app">

<!-- HEADER -->
<app-header v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','exclusive-deals','email-signatures','link-in-bio','account','billing','edit-billing','cancel-reasons','logo-files','profiles-and-covers','business-cards'].includes($route.name)" :propsdata="propsdata"></app-header>
<!-- SIDEBAR -->
<sidebar-header v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','exclusive-deals','email-signatures','link-in-bio','logo-files','profiles-and-covers','business-cards'].includes($route.name)" :propsdata="propsdata" @togglesidebar="togglesidebar"></sidebar-header>
<!-- MANAGE BAR -->
<manage-bar v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['index','bookmarked-logos','email-signatures','link-in-bio','business-cards'].includes($route.name)" :propsdata="propsdata"></manage-bar>
<!-- ACCOUNT TABS -->
<account-header v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['account','billing'].includes($route.name)" :propsdata="propsdata"></account-header>
<!-- CONTENT -->
<transition mode="out-in" name="anima">
<router-view v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50" :key="$route.fullPath" :propsdata="propsdata" @updatepath="update" @open_modal_signup="open_modal_signup"></router-view>
<div v-if="propsdata[0]['account'] && !propsdata[0]['verified']" style="text-align:center;padding-top: 100px;">
<img src="/assets/img/deliver.svg" style="width:400px;max-width:100%;margin-bottom: 15px;">
<h1>Please verify your account</h1>
<p>We just emailed a confirmation link to <strong>{{propsdata[0]['email']}}</strong>.<br>Click the link and you will be signed in</p>
<br><br>
<p>Not your email? <a href="/login">Try again</a></p>
<p>Didn't receive an email? wait a few more seconds or <a href="mailto:support@logo.app">Contact support</a></p>
</div>
</transition>

<!-- UPGRADE TO GET EXCLUSIVE DEALS MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-exclusive-deals" tabindex="-1" role="dialog" aria-labelledby="modal-exclusive-deals" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Unlock all exclusive deals now</h4>
                    <p>Get access to all exclusive deals for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Save up to $9,300</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access to all exclusive deals</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Create unlimited logos</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Full rights and ownership</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_exclusive_deals'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- UPGRADE TO GET BUSINESS CARDS MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-business-cards" tabindex="-1" role="dialog" aria-labelledby="modal-business-cards" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Promote your brand with business cards</h4>
                    <p>Get access to all premium features for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Unlimited Business Cards</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Customize Your Brand Identity</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Diverse Template Selection</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access To All Premium Features</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_business_cards'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- UPGRADE TO GET EMAIL SIGNATURES MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-email-signatures" tabindex="-1" role="dialog" aria-labelledby="modal-email-signatures" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Promote your brand with email signatures</h4>
                    <p>Get access to all premium features for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Unlimited Email Signatures</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Customize Your Brand Identity</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Diverse Template Selection</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access To All Premium Features</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_email_signatures'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- UPGRADE TO GET LINK IN BIO MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-link-in-bio" tabindex="-1" role="dialog" aria-labelledby="modal-link-in-bio" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Promote your brand with your own link in bio</h4>
                    <p>Get access to all premium features for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Unlimited Links In Bio</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Customize Your Brand Identity</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Diverse Template Selection</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access To All Premium Features</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_link_in_bio'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- UPGRADE TO GET LOGO FILES MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-logo-files" tabindex="-1" role="dialog" aria-labelledby="modal-logo-files" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Get high resolution logo files now</h4>
                    <p>Get access to all premium files for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Create Unlimited Logos</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Get Your Font & Logo Files</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Full Ownership</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access To All Premium Features</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_logo_files'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- UPGRADE TO GET PROFILE AND COVERS MODAL -->
<div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="modal fade" id="modal-profiles-and-covers" tabindex="-1" role="dialog" aria-labelledby="modal-profiles-and-covers" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header mx-auto">
                <p class="lead mb-0">Upgrade To Premium</p>
                <button type="button" data-dismiss="modal" aria-label="Close" class="close ml-auto" style="position: absolute;right: 21px;"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="modal-icon display-1-lg"><svg width="204" height="140" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg></span>
                    <h4 class="modal-title my-2">Get high resolution logo files now</h4>
                    <p>Get access to all Profile and cover images for all your brands</p>
                    <ul class="list-group mb-4">
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Create Unlimited Logos</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Profile and cover images</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Full Ownership</li>
                      <li class="list-group-item"><i class="fas fa-check-circle mr-1 text-success"></i> Access To All Premium Features</li>
                    </ul>
                    <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=unlock_profile_and_covers'" class="btn btn-block btn-info">Upgrade Now</a>
                </div>
            </div>
        </div>
    </div>
</div>

</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      propsdata: [{
        account: this.$cookies.get("account"),
        verified: this.$cookies.get("verified"),
        email: '',
        name: '',
        password: '',
        unique_id: '',
        paid: '',
        cancel_at_period_end: '',
        canceled: '',
        cargado: false,
        path: '',
        logo_slug: '',
        logos: [],
        loading_logos: false,
        logos_cargados: false,
        sidebar_mobile: false
      }],
      cancelTokenSource: null
    }
  },
  methods: {
    update() {
      this.propsdata[0]['loading_logos'] = true;
      this.propsdata[0]['logos_cargados'] = false;
      this.propsdata[0]['path'] = this.$route.path;
      this.propsdata[0]['logo_slug'] = this.$route.name;
      if(this.propsdata[0]['logo_slug'] === 'index' || this.propsdata[0]['logo_slug'] === 'bookmarked-logos'){
        if(this.propsdata[0]['logo_slug'] === 'bookmarked-logos'){
          var bookmarked_value = 'yes';
        }
        else{
          var bookmarked_value = '';
        }
        // Cancel the previous request, if it exists
        if (this.cancelTokenSource) {
          this.cancelTokenSource.cancel('Request canceled');
        }

        // Create a new cancel token source
        this.cancelTokenSource = axios.CancelToken.source();

        // Make the Axios request with the new cancel token
        axios.post('/dashboard/cargar-logos.php', {
          bookmarked: bookmarked_value
          }, {
          cancelToken: this.cancelTokenSource.token
          })
          .then(response => {
            this.propsdata[0]['logos'] = response.data;
            this.propsdata[0]['loading_logos'] = false;
            this.propsdata[0]['logos_cargados'] = true;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
   },
   togglesidebar(){
     if(this.propsdata[0]['sidebar_mobile']){
       this.propsdata[0]['sidebar_mobile'] = false;
     }
     else{
       this.propsdata[0]['sidebar_mobile'] = true;
     }
  }
  },
  mounted(){
    // To remove the sessionstorage item when loading dashboard
    sessionStorage.removeItem('last_id_visitors_progress');
    //get stats from user
    if(!this.propsdata[0]['account']){
      //no esta logueado
      window.location.replace("https://logo.app/login");
    }
    else if(!this.propsdata[0]['verified']){
      //no esta verificado
      axios.post('/dashboard/enviar-verificacion.php', {
        })
        .then(response => {
          this.propsdata[0]['email'] = response.data;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
    else{
      axios.post('/dashboard/status.php', {
        })
        .then(response => {
          this.propsdata[0]['email'] = response.data[0].email;
          this.propsdata[0]['name'] = response.data[0].name;
          this.propsdata[0]['password'] = response.data[0].password;
          this.propsdata[0]['unique_id'] = response.data[0].unique_id;
          this.propsdata[0]['paid'] = response.data[0].paid;
          this.propsdata[0]['cancel_at_period_end'] = response.data[0].cancel_at_period_end;
          this.propsdata[0]['canceled'] = response.data[0].canceled;
          this.propsdata[0]['cargado'] = true;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
}
  }
</script>

<style scoped>
.anima-enter{
  opacity: 0;
}
.anima-enter-active{
  transition: opacity 200ms;
  animation: slidein 200ms ease-out forwards;
}
.anima-leave-active{
  transition: opacity 200ms;
  opacity: 0;
  animation: slideout 200ms ease-out forwards;
}

@keyframes slidein {
  from{
    transform: translateY(-20px);
  }
  to{
    transform: translateY(0);
  }
}
@keyframes slideout {
  from{
    transform: translateY(0);
  }
  to{
    transform: translateY(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue